import FieldsetProjectGeneral from './FieldsetProjectGeneral.yaml?component';
import UcProjectGeneral from './UcProjectGeneral.yaml?component';

export { FieldsetProjectGeneral, UcProjectGeneral };
